import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 32px 32px;
  font-family: 'Sora', sans-serif;

  div.requirement,
  div.quantity {
    div.header {
      margin: 20px 0px 30px;

      h3 {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #101d40;
      }

      p {
        color: #7c8db5;
        font-size: 14px;
      }

      @media only screen and (max-width: 768px) {
        text-align: center;
      }
    }
  }

  div.quantity {
    div.values {
      display: flex;
      gap: 25px;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 7px;

  strong {
    color: #101d40;
    margin-bottom: 5px;
  }

  span {
    color: #a6a6a6;
  }

  strong, span {
    font-size: 14px;
  }
`;
